import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { LEAD_DETAIL_COMPONENT, ADD_CONTACT_COMPONENT, QUOTATION_BUILDER_COMPONENT, QUOTATION_ADD_CUSTOMER_COMPONENT } from './component-tokens';
import { LeadDetailComponent } from '../contacts/lead-detail/lead-detail.component';
import { AddContactComponent } from '../add-contact/add-contact.component';
import { QuotationBuilderComponent } from '../product/quotation-builder/quotation-builder.component';
import { QuotationAddCustomerComponent } from '../product/quotation-add-customer/quotation-add-customer.component';

export function provideSharedComponentTokens(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: LEAD_DETAIL_COMPONENT, useValue: LeadDetailComponent },
    { provide: ADD_CONTACT_COMPONENT, useValue: AddContactComponent },
    { provide: QUOTATION_BUILDER_COMPONENT, useValue: QuotationBuilderComponent },
    { provide: QUOTATION_ADD_CUSTOMER_COMPONENT, useValue: QuotationAddCustomerComponent },
  ]);
}

